import { render, staticRenderFns } from "./ScreenShotCarousel.vue?vue&type=template&id=010eface&scoped=true&"
import script from "./ScreenShotCarousel.vue?vue&type=script&lang=js&"
export * from "./ScreenShotCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ScreenShotCarousel.vue?vue&type=style&index=0&id=010eface&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010eface",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VImg,VRow})
